import * as React from "react";
import * as moment from "moment";

interface Props {
    esperienza: any,
    onDelete?: any,
    onEdit?: any
}

interface State {

}

export default class Esperienza extends React.Component<Props, State> {
    render() {

        return (
            <div className={"Esperienza"}>
                <div className={"bignumber"}>{this.props.esperienza.key}</div>
                <h2>{this.props.esperienza.name}</h2>
                <span>Dal {moment(this.props.esperienza.from).format('DD/MM/YYYY')} {(this.props.esperienza.to != null) ? `al ${moment(this.props.esperienza.to).format('DD/MM/YYYY')}` : 'a oggi'}</span>
                <h4>DESCRIZIONE</h4>
                <p>{this.props.esperienza.descr}</p>
                <div className={"inter"}>
                    <div className={"buttons"}>
                        <button type="button" className="btn-default btn-delete" onClick={() => this.props.onDelete()}>Elimina</button>
                        <button type="button" className="btn-default btn-edit" onClick={() => this.props.onEdit()}>Modifica</button>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/frontend/Esperienza.tsx